import Carousel from "react-bootstrap/Carousel";
import Image from "next/image";
import Silder from "../../../../assets/product/product-details/silder.png";
import ImageOne from "../../../../assets/product/product-details/Image-1.png";
import { getFileUrl } from "../../../../utils";

function Carousels({ thumbnailUrl, images }) {
  const _imageUrl = images?.length >= 2 ? getFileUrl + images[1] : thumbnailUrl;

  return (
    <div>
      <div className="product-details-banner">
        <div className="product-details-banner-1"></div>
        <img
          className="product-details-banner-img"
          src={_imageUrl}
          alt="Picture of the author"
        />
      </div>
      {/* <Carousel indicators={false}>
        <Carousel.Item>
          <div class="category-card" style={{ backgroundColor: "#E1D3FA" }}>
            <img src={"/Square_pipe.png"} alt=".." />
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <Image src={thumbnailUrl} width={100} height={100} alt=".." />
        </Carousel.Item>
        <Carousel.Item>
          <Image src={thumbnailUrl} width={100} height={100} alt=".." />
        </Carousel.Item>
      </Carousel> */}
      {/* <div className="d-flex flex-wrap mt-3">
        <Image
          src={ImageOne}
          className="toltip-img card-selected rounded-3"
          alt=".."
        />
        <Image src={ImageOne} className="toltip-img" alt=".." />

        <Image src={ImageOne} className="toltip-img" alt=".." />

        <Image src={ImageOne} className="toltip-img" alt=".." />
      </div> */}
    </div>
  );
}

export default Carousels;
